export const env = {
  GOOGLE_API_KEY: import.meta.env.VITE_GOOGLE_API_KEY || '',
  GOOGLE_CSE_ID: import.meta.env.VITE_GOOGLE_CSE_ID || '',
};
